import { legacy_createStore as createStore, combineReducers, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import { composeWithDevTools } from 'redux-devtools-extension';
// import logger from 'redux-logger';
import aboutusReducer from './aboutus_block/Aboutus';
import homeReducer from './home_block/homeReducer';
import listingReducer from './listing_block/listingReducer';
import profileReducer from './myprofile_block/myProfileReducer';
import registrationReducer from './registration_block/registrationReducer';
import servicesReducer from './services_block/servicesReducer';
import messageReducer from './message_block/Message';
import accountReducer from './account_block/accountReducer';
import businessListingReducer from './listing_block/business/businessReducer';
import investorListingReducer from './listing_block/investor/investorReducer';
import mentorListingReducer from './listing_block/mentor/mentorReducer';
import startupListingReducer from './listing_block/startup/startupReducer';
import lenderListingReducer from './listing_block/lender/lenderReducer';
import franchiseListingReducer from './listing_block/franchise/franchiseReducer';
import contactUsReducer from './contact_us_block/contactUsReducer';

// Combine all reducers into one place
const rootReducer = combineReducers({
  Aboutus: aboutusReducer,
  Home: homeReducer,
  Listing: listingReducer,
  MyProfile: profileReducer,
  Registration: registrationReducer,
  Services: servicesReducer,
  Account: accountReducer,
  Message: messageReducer,
  BusinessListing: businessListingReducer,
  InvestorListing: investorListingReducer,
  MentorListing: mentorListingReducer,
  StartupListing: startupListingReducer,
  LenderListing: lenderListingReducer,
  FranchiseListing: franchiseListingReducer,
  ContactUs: contactUsReducer,
});

const store = createStore(
  rootReducer,
  composeWithDevTools(applyMiddleware(thunk)),
  // composeWithDevTools(applyMiddleware(thunk, logger)),
);

export default store;

export { rootReducer };
